import React from "react";
import PropTypes from "prop-types";
import ErrorView from "../ErrorView/";
import AccessDeniedView from "../AccessDeniedView/";
import NotFoundView from "../NotFoundView/";
import PageTitle from "../PageTitle";

const ErrorPage = props => {
  if (props.error) {
    switch (props.error.status) {
      case 401:
      case 403:
        return <AccessDeniedView />;
      case 404:
        return (
          <PageTitle>
            <NotFoundView />
          </PageTitle>
        );
      default:
        break;
    }
  }

  return <ErrorView error={props.error} />;
};

ErrorPage.propTypes = {
  error: PropTypes.shape({
    status: PropTypes.number
  })
};

export default ErrorPage;
